import { useRouter } from 'next/router';
import classnames from 'classnames';
import React, { useState } from 'react';

export default function SwitchLocale({ className, dark = false }) {
  const { locale, pathname, query, push, asPath } = useRouter();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (locale) => {
    push({ pathname, query }, asPath, { locale, scroll: false });
    handleClose();
  };
  return (
    <div className={classnames(className, 'flex items-center')}>
      {['en', 'it'].map((lang, i) => {
        return (
          <React.Fragment key={i}>
            <button
              className={classnames(
                'w-10 ',
                dark
                  ? { 'text-neutral/50': locale !== lang }
                  : {
                      'text-primary-950': locale !== lang,
                    },
                {
                  'pointer-events-none  text-primary':
                    locale === lang,
                  'hover:text-primary transition-colors ease-in-out duration-300':
                    locale !== lang,
                },
              )}
              aria-label="lang"
              id="locale-button"
              aria-haspopup="true"
              onClick={() => handleChange(lang)}
              aria-expanded={open ? 'true' : undefined}
              aria-controls={open ? 'locale-menu' : undefined}
            >
              <span className="body font-medium md:font-normal uppercase">
                {lang}
              </span>
            </button>
            {i === 0 && (
              <div
                className={classnames(
                  'h-5  w-[2px]',
                  dark ? 'bg-neutral/50' : 'bg-primary-950',
                )}
              ></div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
